import React from 'react'

import styled, { css } from 'styled-components'

const LabelStyled = styled.label`
${props => props.error
        ? css`color: red;`
        : props.info
            ? css`color: #98AAE9;`
            : props.warning
                ? css`color: orange;`
                : props.success && css`color: green;`
    }
${props => props.center && css`text-align: center;`}
`

export const Label = props => {
    return <LabelStyled {...props}>{props.children}{props.required && '*'}</LabelStyled>
}